import secureLocalStorage from "react-secure-storage";
import {
  createRoom, fetchToken, roomId, token as jwtToken
} from "../store/slices/video";
import { useAppDispatch, useAppSelector } from "../store";
import { STORAGE_KEY } from "../constants/video";

const useVideo = () => {
  const dispatch = useAppDispatch();
  const meetingId = useAppSelector(roomId);
  const token = useAppSelector(jwtToken);
  const appointmentId = secureLocalStorage.getItem(STORAGE_KEY) as number;

  const fetchRoom = async (id: number) => {
    const fetchTokenResponse = await dispatch(fetchToken(id));

    // @ts-ignore
    if (fetchTokenResponse.error) {
      throw (fetchTokenResponse.payload);
    }

    const createRoomResponse = await dispatch(createRoom());

    // @ts-ignore
    if (createRoomResponse.error) {
      throw (createRoomResponse.payload as string);
    }
  };

  return {
    fetchRoom,
    meetingId,
    appointmentId,
    token,
  };
};

export default useVideo;
